import { API_ROUTES } from "../constants/apiRoutes";
import { axiosClient } from "./axios";

export interface CreditPaymentPayload {
  orderId: string;
  paymentChannelId: string;
  cardNumber: string;
  cardExpiryMMYY: string;
  cvvCode: string;
  payerName: string;
  paymentTypeFromApp: string;
}
export const postCreditPayment = async (payload: CreditPaymentPayload) => {
  const res = await axiosClient.post(API_ROUTES.CREDIT_PAYMENT, payload);
  return res.data;
};
